<script setup>
import { hybrid } from '@dpgradio/creative'

const props = defineProps({
  title: { type: String, default: '' },
  description: { type: String, default: '' },
  link: { type: String, default: '' },
  isSearch: { type: Boolean, default: false },
  visible: { type: Boolean, default: false },
  left: { type: Number, default: 0 },
  top: { type: Number, default: 0 },
})

const emit = defineEmits(['close'])

function openLink() {
  if (hybrid.isNativeApp()) {
    hybrid.openUrl(props.link, { mode: 'overlay' })
  } else {
    window.open(props.link, '_blank', 'noopener')
  }
}
</script>

<template>
  <div class="popup" :class="{ visible }" :style="{ left: `${left}px`, top: `${top}px` }">
    <button class="popup-close" @click="emit('close')">&times;</button>
    <div v-if="isSearch" class="popup-label">Zoekvlag</div>
    <div class="popup-title">{{ title }}</div>
    <div class="popup-desc">{{ description }}</div>
    <button v-if="link" class="popup-link" @click="openLink">Bekijk meer &rarr;</button>
  </div>
</template>

<style scoped>
.popup {
  display: none;
  position: absolute;
  background: rgba(40, 40, 40, 0.95);
  border: 1px solid #555;
  border-radius: 8px;
  padding: 1rem 1.25rem;
  max-width: 280px;
  min-width: 200px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.5);
  z-index: 20;
}

.popup.visible {
  display: block;
}

.popup-label {
  font-family: var(--font-body);
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #aaa;
  margin-bottom: 0.2rem;
}

.popup-title {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 0.95rem;
  text-transform: uppercase;
  margin-bottom: 0.4rem;
}

.popup-desc {
  font-family: var(--font-body);
  font-size: 0.85rem;
  color: #bbb;
  line-height: 1.5;
}

.popup-close {
  position: absolute;
  top: 0.4rem;
  right: 0.6rem;
  background: none;
  border: none;
  color: #888;
  font-size: 1.1rem;
  cursor: pointer;
  line-height: 1;
}

.popup-close:hover {
  color: #fff;
}

.popup-link {
  display: inline-block;
  margin-top: 0.5rem;
  font-family: var(--font-body);
  font-size: 0.85rem;
  color: #ffe066;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
}

.popup-link:hover {
  text-decoration: underline;
}
</style>
